var noHash = function () {
    if (typeof window !== 'undefined') {
        return window.location.hash === "";
    }
    return false;
};
export default noHash;
